import { render, staticRenderFns } from "./UninstallEvents.vue?vue&type=template&id=25b70216&"
import script from "./UninstallEvents.vue?vue&type=script&lang=js&"
export * from "./UninstallEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports